export default /*glsl*/`
precision mediump float;
uniform vec2 iResolution;
uniform float iTime;
uniform vec4 uLineColor;
uniform vec4 uBgColor0;
uniform vec4 uBgColor1;

const float overallSpeed = 0.2;
const float gridSmoothWidth = 0.015;
const float scale = 5.0;
const float minLineWidth = 0.02;
const float maxLineWidth = 0.5;
const float lineSpeed = 1.0 * overallSpeed;
const float lineAmplitude = 1.0;
const float lineFrequency = 0.2;
const float warpSpeed = 0.2 * overallSpeed;
const float warpFrequency = 0.5;
const float warpAmplitude = 1.0;
const float offsetFrequency = 0.5;
const float offsetSpeed = 1.33 * overallSpeed;
const float minOffsetSpread = 0.6;
const float maxOffsetSpread = 2.0;
const int linesPerGroup = 16;

#define drawSmoothLine(pos, halfWidth, t) smoothstep(halfWidth, 0.0, abs(pos - (t)))
#define drawCrispLine(pos, halfWidth, t) smoothstep(halfWidth + gridSmoothWidth, halfWidth, abs(pos - (t)))

// fourier transform of a random function
float random(float t) {
  return (cos(t) + cos(t * 1.3 + 1.3) + cos(t * 1.4 + 1.4)) / 3.0;
}

float getPlasmaY(float x, float horizontalFade, float offset) {
  return random(x * lineFrequency + iTime * lineSpeed) * horizontalFade * lineAmplitude + offset;
}

void mainImage(out vec4 fragColor, in vec2 fragCoord) {
  vec2 uv = fragCoord.xy / iResolution.xy;
  // Adjust UV coordinates for rotation
  if (iResolution.x < iResolution.y) {
    uv = vec2(uv.y, 1.0 - uv.x);
  }
  vec2 space = (uv - 0.5) * 2.0 * scale / 2.0;
  space.x *= 2.0;

  float horizontalFade = 1.0 - (cos(uv.x * 6.28) * 0.5 + 0.5);
  float verticalFade = 1.0 - (cos(uv.y * 6.28) * 0.5 + 0.5);

  space.y += random(space.x * warpFrequency + iTime * warpSpeed) * warpAmplitude * (0.5 + horizontalFade);
  space.x += random(space.y * warpFrequency + iTime * warpSpeed + 2.0) * warpAmplitude * horizontalFade;

  float linesValue = 0.0;

  for(int l = 0; l < linesPerGroup; l++) {
    float normalizedLineIndex = float(l) / float(linesPerGroup);
    float offsetTime = iTime * offsetSpeed;
    float offsetPosition = float(l) - space.x * offsetFrequency;
    float rand = random(offsetPosition + offsetTime) * 0.5 + 0.5;
    float halfWidth = mix(minLineWidth, maxLineWidth, rand * horizontalFade) / 2.0;
    float offset = random(offsetPosition + offsetTime * (1.0 + normalizedLineIndex)) * mix(minOffsetSpread, maxOffsetSpread, horizontalFade);
    float linePosition = getPlasmaY(space.x, horizontalFade, offset);
    float line = drawSmoothLine(linePosition, halfWidth, space.y) / 2.0 + drawCrispLine(linePosition, halfWidth * 0.15, space.y);

    linesValue += line * rand;
  }

  // Use uniforms for background and line color, and blend properly
  vec4 bg = mix(uBgColor0, uBgColor1, uv.x);
  bg *= verticalFade;
  bg.a = 1.0;

  // Blend lines using uLineColor
  vec4 finalColor = bg + uLineColor * linesValue;
  finalColor = clamp(finalColor, 0.0, 1.0);

  fragColor = finalColor;
}

void main() {
  mainImage(gl_FragColor, gl_FragCoord.xy);
}

`;